<template>
    <div class="tab-detail">
        <div class="header">
            <div class="title">{{ $t("whatsapp_business_api.wpBussChannelDetail") }}</div>
            <div class="subtitle">{{ $t("whatsapp_business_api.manageChannelDetail") }}</div>
        </div>

        <template v-if="shouldShowIframe">
            <div class="onboarding-wrapper">
                <SupsisButton type="primary" class="integration-button" @click="openOnboardingLink" large primary>
                    {{ $t("Whatsapp Entegrasyonunu Yap") }}
                </SupsisButton>

                <SupsisButton class="integration-button" @click="connectSupportTeamRequest" xlarge ghost icon="help">
                    {{ $t("Yardım Al") }}
                </SupsisButton>
                <a-alert
                class="mt-4"
                message="Bilgilendirme"
                description="Eğer WhatsApp hattınızı başarılı bir şekilde tanımladıysanız, bu ekranın güncellenmesi biraz zaman alabilir."
                type="info"
                show-icon
            />
            </div>


        </template>
        <template v-else>
            <a-form>
                <div class="form-wrapper">
                    <a-alert message="Webhook Address" type="success">
                        <div slot="description">
                            <div class="webhook-info">
                                <span>
                                    <a-icon type="copy" @click="copyWebhookAddress" />
                                </span>
                                <span>OLD: {{ getWebhookAddress() }}</span>
                            </div>
                            <div class="webhook-info">
                                <span>
                                    <a-icon type="copy" @click="() => copyWebhookAddress(true)" />
                                </span>
                                <span>NEW: https://webhook.supsis.ai/waba</span>
                            </div>
                        </div>
                    </a-alert>
                    <div class="input-wrapper">
                        <label>{{ $t("whatsapp_business_api.channelName") }}</label>
                        <a-input
                            :placeholder="$t('whatsapp_business_api.channelName')"
                            v-model="clone.name"
                            v-validate="'required'"
                            name="channelName"
                        />
                    </div>
                    <div class="input-wrapper">
                        <label>API Key </label>
                        <a-input
                            placeholder="API Key "
                            v-model="clone.payload.apiKey"
                            v-validate="'required'"
                            name="apiKey"
                            @focus="showWarning"
                        />
                    </div>
                    <div class="input-wrapper">
                        <label>App ID</label>
                        <a-input
                            placeholder="App ID "
                            v-model="clone.payload.appId"
                            v-validate="'required'"
                            name="appId"
                            @focus="showWarning"
                        />
                    </div>
                    <div class="input-wrapper">
                        <label>App Name</label>
                        <a-input
                            placeholder="App Name "
                            v-model="clone.payload.appName"
                            v-validate="'required'"
                            name="appName"
                            @focus="showWarning"
                        />
                    </div>
                    <div class="input-wrapper">
                        <label>{{ $t("whatsapp_business_api.phoneNumberE164") }}</label>
                        <a-input
                            :placeholder="$t('whatsapp_business_api.phoneNumberE164Place')"
                            v-model="clone.payload.phoneNumber"
                            v-validate="'required'"
                            name="phoneNumber"
                            @focus="showWarning"
                        />
                    </div>
                </div>
            </a-form>
            <ChannelForwardSetting :channel="clone" />
            <div class="form-footer">
                <div class="actions">
                    <a-button class="pr-confirm-btn" @click="handleSave" type="primary" :disabled="loading">
                        {{ $t("message.update") }}
                    </a-button>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import Vue from "vue";
import VisibilityChanger from "../../WhatsappV1/VisibilityChanger.vue";
import _ from "lodash";
import log2 from "../../../../utils/log2";
import CONFIG from "../../../../config/config";
import { copyText2Clipboard } from "../../../../utils/utils";
import { mapActions, mapState } from "vuex";
import ChannelForwardSetting from "../../IntegrationChannelsItem/ChannelForwardSetting.vue";
import { publishMessage, SystemMessageTypes } from "../../../../utils/systemPubSub";
import SupsisButton from "@/views/Pages/Settings/components/SupsisButton.vue";

const log = log2("UpdateDetail.vue");
export default Vue.extend({
    name: "UpdateDetail",
    components: { VisibilityChanger, ChannelForwardSetting, SupsisButton },
    props: {
        value: {
            required: true,
        },
    },
    data() {
        return {
            clone: _.cloneDeep(this.value),
            loading: false,
            showStories: !!this.value.forward.story,
        };
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            stories: (state) => state.CB.stories,
            subjects: (state) => _.get(state.subject.subjects, "data", []) || [],
            departments: (state) => _.get(state.subject.subjects, "data", []) || [],
        }),
        shouldShowIframe() {
            return this.clone.onboard && this.clone.onboard.live === false && this.clone.onboard.onboardLink;
        },
    },
    methods: {
        ...mapActions({
            updateChannel: "channel/updateChannel",
            listChannels: "channel/listChannels",
            listStories: "CB/listStories",
        }),
        showWarning() {
            this.$message.warning(
                "Bu alanı değiştirmek bağlantıyı bozabilir. Devam etmek istediğinizden emin misiniz?"
            );
        },
        toggleChatbot() {
            if (this.showStories) {
                this.clone.forward.story = null;
            } else {
                if (this.stories[0]) {
                    this.clone.forward.story = this.stories[0]._id;
                }
            }
            this.showStories = !this.showStories;
        },
        getWebhookAddress() {
            return `${CONFIG.SOCKET_URL}/webhook/whatsapp-business-api/gupshup/${this.site._id}/${this.clone._id}`;
        },
        getSubjectTitle(department) {
            const validLangs = Object.keys(department.languageContent);
            const targetLang = validLangs.includes(this.$i18n.locale) ? this.$i18n.locale : validLangs[0];
            const key = `languageContent.${targetLang}.name`;
            return _.get(department, key);
        },
        copyWebhookAddress(isNew = false) {
            copyText2Clipboard(isNew ? `https://webhook.supsis.ai/waba` : this.getWebhookAddress());
            this.$message.success("Webhook address copied to clipboard");
        },
        getDepartmentTitle(department) {
            const validLangs = Object.keys(department.languageContent);
            const targetLang = validLangs.includes(this.$i18n.locale) ? this.$i18n.locale : validLangs[0];
            const key = `languageContent.${targetLang}.name`;
            return _.get(department, key);
        },
        toggleDepartmentForwardingRule() {
            if (!!this.clone.forward.department) {
                this.clone.forward.department = null;
            } else {
                if (this.departments[0]) {
                    this.clone.forward.department = this.departments[0]._id;
                }
            }
            this.clone = _.cloneDeep(this.clone);
        },
        handleSave() {
            const isValid = true;
            if (isValid) {
                const isChanged = !_.isEqual(this.value, this.clone);
                if (!isChanged) {
                    return;
                }
                const payload = this.clone;
                this.loading = true;
                this.updateChannel(payload)
                    .then(() => {
                        this.listChannels();
                        this.$message.success(this.$t("whatsapp_business_api.channelUpdatedSucs"));
                        this.$emit("input", this.clone);
                        this.clone = _.cloneDeep(this.clone);
                    })
                    .catch((err) => {
                        console.error(err);
                        this.$message.error(this.$t("whatsapp_business_api.faieldUpdateChannel"));
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        openOnboardingLink() {
            try {
                const url = new URL(this.clone.onboard.onboardLink);
                window.open(url.toString(), "_blank", "noopener,noreferrer");
            } catch (error) {
                console.error("Geçersiz URL:", error);
                this.$message.error(this.$t("Geçersiz bağlantı adresi lütfen destek ekibiyle iletişime geçin"));
            }
        },
        connectSupportTeamRequest() {
            publishMessage(SystemMessageTypes.CONNECT_SUPPORT_TEAM, {
                initialMessage: "/whatsapp busines api için yardım almak istiyorum",
                largeMode: true,
            });
        },
    },
    mounted() {
        this.listStories();
    },
    watch: {
        value: {
            handler: function (val) {
                const isChanged = !_.isEqual(val, this.clone);
                if (isChanged) {
                    log("value changed=>", val);
                    this.clone = _.cloneDeep(val);
                }
            },
            deep: true,
        },
    },
});
</script>

<style scoped lang="scss">
.tab-detail {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 20px;

    .header {
        display: flex;
        justify-content: space-between;
        padding-bottom: 10px;

        border-bottom: 1px solid var(--color-border-default);

        .title {
            font-size: 18px;
            font-weight: 700;
            color: var(--color-text-strong-default);
        }

        .subtitle {
            font-size: 14px;
            color: var(--color-text-strong-default);
        }
    }

    .onboarding-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 70vh;
        gap: 10px;
        flex-direction: column;

        .integration-button {
            padding: 20px 40px;
            height: auto;
            font-size: 24px;
            line-height: 1.5;
            border-radius: 12px;
            transition: all 0.3s ease;

            &:hover {
                transform: scale(1.05);
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
            }

            &:active {
                transform: scale(0.98);
            }
        }
    }
}
</style>
